/* eslint-disable react/prop-types */
import { FiEye } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { handleGetLanguage } from "../utils/languageStorage";

export default function ShopItemCard({ item }) {
  const language = handleGetLanguage();
  const location = useLocation();

  const productName = language === "ka" ? item.name.ka : item.name.en;

  const storeScrollPosition = () => {
    localStorage.setItem("shopScrollY", window.scrollY.toString());
  };

  const linkToProduct = {
    to: `/product-detail/${item.id}`,
    state: {
      fromShop: true,
      from: location.pathname + location.search,
    },
    onClick: storeScrollPosition,
  };

  const imageUrl = item?.images?.[0]?.includes("http")
    ? item.images[0]
    : `https://api.onlybrands.ge/storage/${item.images[0]}`;

  return (
    <div className="group cursor-pointer relative">
      {/* ─── Product Image ─── */}
      <Link
        {...linkToProduct}
        className="overflow-hidden shadow dark:shadow-gray-800 group-hover:shadow-lg group-hover:dark:shadow-gray-800 rounded-md duration-500 block"
      >
        <img
          src={imageUrl}
          alt={productName}
          className="group-hover:scale-110 duration-500 w-full"
          style={{
            height: "300px",
            objectFit: "contain",
            maxWidth: "100%",
          }}
        />
      </Link>

      {/* ─── Quick View ─── */}
      <ul className="list-none absolute top-[10px] end-4 opacity-0 group-hover:opacity-100 duration-500 space-y-1">
        <li>
          <Link
            {...linkToProduct}
            className="size-10 inline-flex items-center justify-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
          >
            <FiEye className="size-4" />
          </Link>
        </li>
      </ul>

      {/* ─── Product Info ─── */}
      <div className="mt-4">
        <Link {...linkToProduct} className="hover:text-orange-500 text-lg font-medium">
          {productName}
        </Link>

        <div className="flex justify-between items-center mt-1">
          {item.discounted_price ? (
            <p className="font-medium">
              GEL{item.discounted_price}{" "}
              {item.price && <del className="text-slate-400">GEL{item.price}</del>}
            </p>
          ) : (
            <p>GEL{item.price}</p>
          )}
        </div>
      </div>
    </div>
  );
}
